import { Pipe, PipeTransform, inject } from '@angular/core';

import { Observable, of, concat } from 'rxjs';
import { map } from 'rxjs/operators';

import { TenantService } from '../../tenant/services/tenant.service';
import { arrayToPropertyValueRecord } from '../utils/array-to-record';

@Pipe({
  standalone: true,
  name: 'tenantNameResolver$',
})
export class TenantNameResolverPipe implements PipeTransform {
  private readonly service = inject(TenantService);

  public transform(tenantShortName: string): Observable<string> {
    if (!tenantShortName) {
      return of(tenantShortName);
    }

    return concat(
      of(tenantShortName),
      this.service.getAll().pipe(
        map((tenants) => arrayToPropertyValueRecord(tenants, 'tenantShortName', 'displayName')),
        map((tenantLookup) => tenantLookup[tenantShortName] || tenantShortName)
      )
    );
  }
}
